import {openResourceModal} from '../../core/modalCommand';
import {reportActiveAgentModalLifecycle} from '../../core/modalLifecycle';
import {
	SSID_TEMPLATE_EDIT_MODAL_EVENT,
	SSID_TEMPLATE_CREATE_MODAL_EVENT,
	SSID_TEMPLATE_DELETE_MODAL_EVENT,
} from './events';

/**
 * Open the Add SSID Template form.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSsidTemplateCreateModal(command, envelope) {
	return openResourceModal(
		SSID_TEMPLATE_CREATE_MODAL_EVENT,
		command,
		envelope,
	);
}

/**
 * Open the Edit SSID Template form.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSsidTemplateEditModal(command, envelope) {
	return openResourceModal(
		SSID_TEMPLATE_EDIT_MODAL_EVENT,
		command,
		envelope,
	);
}

/**
 * Open the SSID Template delete confirmation.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSsidTemplateDeleteModal(command, envelope) {
	return openResourceModal(
		SSID_TEMPLATE_DELETE_MODAL_EVENT,
		command,
		envelope,
	);
}

/**
 * Report an SSID Template modal outcome.
 * @param {'modal.cancelled'|'modal.saved'} eventType lifecycle event
 * @return {Promise<object|null>} agent response
 */
export function reportSsidTemplateModalLifecycle(eventType) {
	return reportActiveAgentModalLifecycle(eventType);
}
